import { css } from 'styled-components';

export const FontStyle = css`
    font-family: Helvetica;
    color: #17394D;
`;
